import { InputLabel } from '@eluve/components';

import { BundleTemplateSelector } from './BundleTemplateSelector';

interface NewAppointmentTemplateProps {
  showHeader?: boolean;
  usesPortal?: boolean;
  side?: 'bottom' | 'left' | 'right' | 'top';
}

// Bundles are enabled for all tenants (ENG-4406), so this always renders the
// bundle selector. The previous appointment-mode branching (audio copilot vs
// manual charting) and Mastra-flag handling have been removed.
export const NewAppointmentTemplateSelector: React.FC<
  NewAppointmentTemplateProps
> = ({ showHeader = true, usesPortal, side }) => {
  return (
    <InputLabel label={showHeader ? 'Template' : null}>
      <BundleTemplateSelector usesPortal={usesPortal} side={side} />
    </InputLabel>
  );
};
